import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from 'react';
import { ThemeProvider, responsiveFontSizes } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, CircularProgress, Alert, Button, Typography } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Auth from './pages/Auth';
import Nasdaq100XGBoost from './pages/Nasdaq100XGBoost';
import ProtectedRoute from './components/ProtectedRoute';
import theme from './utils/theme';
var queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            staleTime: 300000,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true
        }
    }
});
function ErrorFallback(_a) {
    var error = _a.error, resetErrorBoundary = _a.resetErrorBoundary;
    return (_jsx(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', p: 3 }, children: _jsxs(Alert, { severity: "error", action: _jsx(Button, { color: "inherit", size: "small", onClick: resetErrorBoundary, children: "Try again" }), children: [_jsx(Typography, { variant: "h6", children: "Something went wrong" }), error.message] }) }));
}
function LoadingFallback() {
    return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }, children: [_jsx(CircularProgress, {}), _jsx(Typography, { variant: "body1", color: "text.secondary", children: "Loading..." })] }));
}
function AppRoutes() {
    var _a = useAuth(), currentUser = _a.currentUser, loading = _a.loading, logout = _a.logout;
    if (loading) {
        return _jsx(LoadingFallback, {});
    }
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Navigate, { to: "/nasdaq100", replace: true }) }), _jsx(Route, { path: "/auth", element: _jsx(Auth, {}) }), _jsx(Route, { path: "/nasdaq100", element: _jsx(ProtectedRoute, { children: _jsx(Nasdaq100XGBoost, {}) }) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] }));
}
function App() {
    return (_jsx(ErrorBoundary, { FallbackComponent: ErrorFallback, children: _jsx(AuthProvider, { children: _jsxs(ThemeProvider, { theme: responsiveFontSizes(theme), children: [_jsx(CssBaseline, {}), _jsx(QueryClientProvider, { client: queryClient, children: _jsx(Router, { children: _jsx(Suspense, { fallback: _jsx(LoadingFallback, {}), children: _jsx(AppRoutes, {}) }) }) })] }) }) }));
}
export default App;
